import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { useAuth } from '../context/AuthContext';
import { useRouter } from 'expo-router';
import { webStyles } from '../../styles/web.styles';

export default function WebHome() {
  const { user, signOut } = useAuth();
  const router = useRouter();

  const handleLogout = async () => {
    try {
      await signOut();
      router.replace('/auth');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  if (!user) {
    return (
      <View style={webStyles.container}>
        <Text style={webStyles.welcomeText}>Loading...</Text>
      </View>
    );
  }

  return (
    <View style={webStyles.container}>
      <View style={webStyles.card}>
        <View style={webStyles.profileSection}>
          <Text style={webStyles.welcomeText}>مرحباً بك!</Text>
          <Text style={webStyles.subtitle}>الملف الشخصي</Text>
        </View>

        <View style={webStyles.profileSection}>
          <Text style={webStyles.nameText}>{user.displayName || user.name || 'المستخدم'}</Text>
          <Text style={webStyles.emailText}>{user.email}</Text>
          <Text style={webStyles.providerText}>
            Provider: {user.providerData?.[0]?.providerId || user.provider || 'email'}
          </Text>
        </View>

        <TouchableOpacity style={webStyles.logoutButton} onPress={handleLogout}>
          <Text style={webStyles.logoutButtonText}>تسجيل الخروج</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
}